/**
 * Save a Blob as a file. Uses the `<a download>` pattern because it works in
 * the browser and in the Capacitor app, where opening a blob: URL in a new
 * window does not.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
